/* eslint no-debugger: "off" */

import slider from '../autoload/slider';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    slider($('.hero'))
    slider($('.mobile-only.home-actus'), {infinite: false, autoplay: false})
    slider($('.operations-pictures .mobile-only'))
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/home.js